import { render, staticRenderFns } from "./WorkflowStateStatusDisplay.vue?vue&type=template&id=22f8a50a&"
import script from "./WorkflowStateStatusDisplay.vue?vue&type=script&lang=ts&"
export * from "./WorkflowStateStatusDisplay.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports